import { GButtonGroup } from '@garmin/components-global-web/dist/components/g-button-group.js';

if (!customElements.get('g-button-group')) {
  customElements.define('g-button-group', GButtonGroup);
}